<div class="page__content">
    <div class="content__inner">
        <div id="container">
            <div class="left">
                <img [src]="logoPanelUrl" alt="Logo" class="logo">
                <div class="px-3" style="font-family:'Lato !important';" *ngFor="let informacion of InfoRegistro">
                    <h3 *ngIf="!informacion.cuerpo">{{ 'REGISTER.TITLE' | translate }}</h3>
                    <p><strong *ngIf="informacion.cuerpo">{{informacion.tituloWeb}}</strong> {{informacion.cuerpo}}</p>
                </div>
                <div>
                    <p class="autofirma">{{ 'REGISTER.AUTOFIRMA' | translate }} <a href="http://firmaelectronica.gob.es/Home/Descargas.html" class="linkDestacado">{{ 'REGISTER.AUTOFIRMA_LINK' | translate }}</a> {{ 'REGISTER.AUTOFIRMA_SUFFIX' | translate }}</p>
                </div>
            </div>
            <div class="center">
                <div>
                    <h1>{{ 'APP.TITLE_REGISTER' | translate }}</h1>
                    <p>
                        {{ 'APP.TEXT_REGISTER' | translate }}
                    </p>
                </div>
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
                    <div class="row pt-4">
                        <div class="col-sm-12 ml-4">
                            <h6>{{ 'REGISTER.PERSONAL_DATA' | translate }}</h6>
                        </div>
                        <div class="border row paddingCustom marginCustom">
                            <div class="col-sm-4">
                                <label class="requerido">{{ 'REGISTER.NAME' | translate }}</label>
                                <input type="text" class="form-control" name="nombre" formControlName="nombre"
                                    minlength="3" maxlength="20"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['nombre'].errors}" />
                            </div>

                            <div class="col-sm-4">
                                <label class="requerido">{{ 'REGISTER.FIRST_NAME' | translate }}</label>
                                <input type="text" class="form-control" name="apellido1" formControlName="apellido1"
                                    minlength="3" maxlength="20"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['apellido1'].errors}" />
                            </div>

                            <div class="col-sm-4">
                                <label>{{ 'REGISTER.SECOND_NAME' | translate }}</label>
                                <input type="text" class="form-control" name="apellido2" formControlName="apellido2"
                                    minlength="3" maxlength="20"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['apellido2'].errors}" />
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_PERSONA' | translate }}</label>
                                <select class="form-control" formControlName="tipo_persona"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_persona'].errors}">
                                    <option *ngFor="let tipopersona of TPersonas" [value]="tipopersona.id">
                                        {{ tipopersona.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_DOCUMENTO' | translate }}</label>
                                <select class="form-control" formControlName="tipo_documento"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_documento'].errors}">
                                    <option *ngFor="let tipodocumento of TDocumentos" [value]="tipodocumento.id">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                                <input name="numero_documento" class="w-100 text-align-center form-control"
                                    formControlName="numero_documento"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['numero_documento'].errors}" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4 mb-3">
                        <div class="col-sm-12 ml-4">
                            <h6>{{ 'REGISTER.CONTACT_DATA' | translate }}</h6>
                        </div>
                        <div class="border row paddingCustom marginCustom">
                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                                <select formControlName="tipo_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_via'].errors}">
                                    <option *ngFor="let vias of TVias" [value]="vias.id">
                                        {{ vias.tipovianormalizado }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-6">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                                <input type="text" formControlName="nombre_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['nombre_via'].errors}" />
                            </div>


                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.N_DE_LA_VIA' | translate }}</label>
                                <input type="text" formControlName="numero_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['numero_via'].errors}" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.BLOQUE' | translate }}</label>
                                <input type="text" formControlName="bloque" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                                <input type="text" formControlName="escalera" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.PISO' | translate }}</label>
                                <input type="text" formControlName="piso" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                                <input type="text" formControlName="puerta" class="form-control" />
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.PAIS' | translate }}</label>
                                <select formControlName="pais" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['pais'].errors}">
                                    <option *ngFor="let _pais of TPais" [value]="_pais.id">
                                        {{ _pais.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.COMUNIDAD' | translate }}</label>
                                <select formControlName="ccaa" class="form-control" (change)="onChangeProvincia($event)"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['ccaa'].errors}">
                                    <option *ngFor="let ccaa of TComunidades" [value]="ccaa.id">
                                        {{ ccaa.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                                <select formControlName="provincia" class="form-control"
                                    (change)="onChangeMunicipio($event)"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['provincia'].errors}">
                                    <option *ngFor="let provincia of TProvincias" [value]="provincia.id">
                                        {{ provincia.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                                <select formControlName="municipio" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['municipio'].errors}">
                                    <option *ngFor="let municipio of TMunicipios"
                                        [value]="municipio.municipioPK['municipio_id']">
                                        {{ municipio.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                                <input type="text" mask="9{5}" formControlName="codigo_postal" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['codigo_postal'].errors}" />
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TELEFONO' | translate }}</label>
                                <input type="text" class="form-control" name="telefono" formControlName="telefono"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['telefono'].errors}" />
                            </div>
                                <div class="col-sm-4 mt-3" style="background-color:var(--blue-pale); padding-bottom:15px; margin-top:2rem !important">
                                    <label class="requerido">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                                    <input type="email" name="email" class="form-control" formControlName="email"
                                        [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
                                </div>
    
                                <div class="col-sm-4 mt-3" style="background-color:var(--blue-pale); padding-bottom:15px; margin-top:2rem !important">
                                    <label class="requerido">{{ 'PLACEHOLDER.CONTRASENA' | translate }}</label>
                                    <input type="password" class="form-control" name="password" formControlName="password"
                                        minlength="6"
                                        [ngClass]="{'is-invalid': submitted && this.form.controls['password'].errors}" />
                                </div>
                                <div class="col-sm-4 mt-3" style="background-color:var(--blue-pale); padding-bottom:15px; margin-top:2rem !important">
                                    <label class="requerido">{{ 'TRAMITE.FORM.LABEL.CONFIRMAR_CONTRASENA' | translate }}</label>
                                    <input type="password" class="form-control" name="password_confirmacion"
                                        formControlName="password_confirmacion" minlength="6"
                                        [ngClass]="{'is-invalid': submitted && this.form.controls['password_confirmacion'].errors}" />
                                </div>
                            </div>
                        </div>
                    
                    <div class="w-100 d-flex justify-content-end">
                        <button type="submit" class="btn btn-primary" [disabled]="register? 'true' : null">
                            {{ 'REGISTER.SUBMIT' | translate }}
                        </button>
                    </div>

                </form>
                <div class="alert alert-success" *ngIf="isSuccessful">
                    Se ha registrado satisfactoriamente!
                </div>
            </div>
        </div>
    </div>
</div>